import { useEffect, useState, useCallback, useMemo } from 'react';
import { isMobile } from 'react-device-detect';

const MOBILE = 'mobile';
const DESKTOP = 'desktop';

export const defaultMediaQueries = {
  '(min-width:1025px)': DESKTOP,
  '(min-width:0px)': MOBILE
};

export const useMedia = (isMobileView, queries = defaultMediaQueries) => {
  const match = () => {
    if (typeof window === 'object') {
      const query = Object.keys(queries).find(q => matchMedia(q).matches);
      return queries[query];
    }

    if (isMobileView) {
      return MOBILE;
    }

    return DESKTOP;
  };

  // State and setter for current value
  const [value, set] = useState(match());

  const handler = useCallback(() => {
    const newMatch = match();
    if (newMatch !== value) {
      set(newMatch);
    }
  }, [value]);

  const is = useMemo(
    () => ({
      mobile: isMobile || value === MOBILE,
      notMobile: !isMobile && value !== MOBILE
    }),
    [value]
  );

  useEffect(() => {
    window.addEventListener('resize', handler);

    return () => window.removeEventListener('resize', handler);
  }, [value]);

  return { is };
};
